// A copy of Harbor's item id rule (packages/integrations/harbor/shared/src/item-id.ts),
// kept apart so that LaunchDarkly changes no other integration.
//
// An item's id has to be safe wherever it's used as a name: as a command-line
// argument, where a leading hyphen would read as a flag, inside a request's
// `<account>/<target>` argument, where a slash would end it, and inside the
// names of Terraform resources and of an IAM policy.
const ITEM_ID_PATTERN = /^[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;

// The length of a DNS label. No system that takes the id sets it: it is short
// enough to leave room for what a generated name puts around the id, under
// the 128 characters IAM allows an inline policy's name.
const ITEM_ID_MAX_LENGTH = 63;

export const INVALID_ITEM_ID = `Use lowercase letters, digits and hyphens, starting and ending with a letter or digit, up to ${ITEM_ID_MAX_LENGTH} characters.`;

/** Whether `id` can be the id of a LaunchDarkly connector or account item.
 * It's checked as it stands: an id isn't trimmed. */
export const isItemId = (id: unknown): id is string =>
  typeof id === "string" &&
  id.length <= ITEM_ID_MAX_LENGTH &&
  ITEM_ID_PATTERN.test(id);
